module.exports = __webpack_public_path__ + "img/Character-jumping.9033499e.svg";